import { useCallback } from 'react';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';

const { IntentActionTrigger } = MojitoPresentation.Base.Intent;
const { utils: EventUtils } = MojitoServices.SportsContent.Events;

/**
 * Builds the click handler of a selection card. A racing event opens the meeting it belongs to
 * rather than the event page, so this cannot use the shared event card click hook.
 *
 * @function useSelectionCardClick
 *
 * @param {object} event - Event the card represents.
 * @param {object} appContext - Mojito application context.
 *
 * @returns {Function} Memoized click handler.
 * @memberof Mojito.Modules.EventCards.Selection.Hooks
 */
export const useSelectionCardClick = (event, appContext) =>
    useCallback(() => {
        const { sportId, id: eventId } = event;

        if (EventUtils.isRaceEventType(event.eventType)) {
            IntentActionTrigger.showMeetingsRaces(sportId, event.details.meetingId, eventId);
        } else {
            IntentActionTrigger.showSportEvent(sportId, eventId);
        }
        appContext.analyticsEmitter.emitAnalytics('eventCardClicked', event.canonicalName);
    }, [event, appContext.analyticsEmitter]);
